// WESPOアプリのインターフェースを定義するため、Windowを拡張
declare global {
  interface Window {
    webkit: {
      messageHandlers: {
        externalLink: {
          postMessage: (args: string) => void;
        };
      };
    };
  }
}
interface MyApp {
  externalLink: (args: string) => void;
}
declare var MyApp: MyApp;

/**
 * 外部リンクへの遷移
 */
export const handelExternalLinkClick = (
  event: React.MouseEvent | null,
  url: string
) => {
  if (!url) return;

  if (event) {
    event.preventDefault();
  }

  const messageJson = JSON.stringify({ url: url });
  const ua = window.navigator.userAgent;

  if (/WESPO-iOS-App/.test(ua)) {
    // iOSの場合
    window.webkit.messageHandlers.externalLink.postMessage(messageJson);
  } else if (/WESPO-Android-App/.test(ua)) {
    // Androidの場合
    MyApp.externalLink(messageJson);
  } else {
    // その他の場合
    window.location.href = url;
  }
};
